import * as t from 'io-ts'

export const ofTypeForTag = <Tag extends string>(_tag: Tag) => <X extends { [k in Tag]: any }>(
  _t: X[Tag]
): { [k in X[Tag]]: X } => ({ [_t]: ((undefined as any) as X) as unknown } as { [k in X[Tag]]: X })

export const ofIOTypeForTag = <Tag extends string>(_tag: Tag) => <V extends string>(_t: V) => <
  V extends string,
  A extends { [k in Tag]: V },
  O,
  I
>(
  _tp: t.Type<A, O, I>
): { [k in typeof _t]: t.TypeOf<typeof _tp> } =>
  ({ [_t]: (undefined as any) as t.TypeOf<typeof _tp> } as { [k in typeof _t]: t.TypeOf<typeof _tp> })



// WEBPACK FOOTER //
// ./src/framework/unionize.ts